import React, { useState } from "react";
import { Flex, Box } from "rebass";
import Compressor from "compressorjs";

import Thumbnail from "./Thumbnail";
import Button from "../Button";

/**
 * Base64 string to content type
 *
 * @param string
 * @param string
 * @return Blob
 */
const base64toBlob = (base64Data, contentType) => {
  contentType = contentType || "";
  var sliceSize = 1024;
  var byteCharacters = atob(base64Data);
  var bytesLength = byteCharacters.length;
  var slicesCount = Math.ceil(bytesLength / sliceSize);
  var byteArrays = new Array(slicesCount);

  for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
    var begin = sliceIndex * sliceSize;
    var end = Math.min(begin + sliceSize, bytesLength);

    var bytes = new Array(end - begin);
    for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
      bytes[i] = byteCharacters[offset].charCodeAt(0);
    }
    byteArrays[sliceIndex] = new Uint8Array(bytes);
  }
  return new Blob(byteArrays, { type: contentType });
};

/**
 * Image Compressor
 *
 * @param array
 * @return array
 */
const compressImages = (files: any) =>
  new Promise(async (resolve) => {
    let processed: any = [];

    // Loop Thru Files
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      await new Promise((r) => {
        new Compressor(file, {
          quality: 0.8,
          maxHeight: 1000,
          maxWidth: 1000,
          success(blob) {
            processed.push(new File([blob], file.name, { type: blob.type }));
            r();
          },
        });
      });
    }
    resolve(processed);
  });

/**
 * Get Size
 */
const getFileSizes = (arr: any) => {
  let size = 0;
  arr.forEach((file) => {
    size += file.size;
  });

  return size;
};

function AddImage({ name, addText, setField, onOptimizing, disabled = false }) {
  const [showInput, setShowInput] = useState(false);

  if (showInput) {
    return (
      <Flex sx={{ width: "100%" }}>
        <input
          id="file"
          multiple
          name="file"
          key={`file-${name}`}
          type="file"
          disabled={disabled}
          onChange={async (event) => {
            onOptimizing(true);
            setShowInput(false);
            const files = [...(event.target.files as any)];

            // Compress Files
            const compress = await compressImages(files);

            setField(name, compress);
            onOptimizing(false);
          }}
          className="form-control"
        />
        <Button
          onClick={() => {
            setShowInput(false);
          }}
        >
          Cancel
        </Button>
      </Flex>
    );
  }

  return (
    <Button
      onClick={() => {
        setShowInput(true);
      }}
    >
      {addText}
    </Button>
  );
}

export default function ImageInput({
  name,
  labelText,
  as,
  type,
  inputProps,
  labelProps,
  value,
  setField,
  disabled = false,
  onOptimizing = () => {},
  ...props
}: {
  name: string;
  labelText: string;
  as?: any;
  type?: any;
  inputProps?: any;
  labelProps?: any;
  value?: any;
  setField?: any;
  disabled: boolean;
  onOptimizing: any;
}) {
  const image = value;
  return (
    <>
      <Box>
        <Box
          as="label"
          variant="label"
          {...props}
          {...labelProps}
          htmlFor={name}
          sx={{ display: "block" }}
        >
          {labelText}
        </Box>
        <Box>
          <Thumbnail
            thumbnail={image}
            key={(image && image.lastModified) || null}
          />
        </Box>
        <AddImage
          name={name}
          addText={image ? "Change Image" : "Add Image"}
          setField={setField}
          disabled={disabled}
          onOptimizing={onOptimizing}
        />
      </Box>
    </>
  );
}
